/**
 * X Ads — where the screens live.
 *   /x-ads                  campaigns · line items · promoted posts (XA_HOME)
 *   /x-ads/campaigns/new    the campaign wizard (everything created paused)
 *   /x-ads/creatives        posts, image library
 *   /x-ads/tools            lead forms + leads, custom audiences
 *   /x-ads/reporting        results from the reporting collection
 *   /x-ads/account          connect X and pick the ads account (never gated; the OAuth callback returns here)
 */
export const XA = '/x-ads';
export const XA_HOME = `${XA}/campaigns`;
export const XA_NEW = `${XA}/campaigns/new`;
export const XA_CREATIVES = `${XA}/creatives`;
export const XA_TOOLS = `${XA}/tools`;
export const XA_REPORTING = `${XA}/reporting`;
export const XA_ACCOUNT = `${XA}/account`;
